import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { api } from "@lr-notitia/notitia-engineer/client";
import { useGraphStore } from "./graph";
import { useDomainStore } from "./domain";
import router from "../router";

let graphStore: ReturnType<typeof useGraphStore>;
let domainStore: ReturnType<typeof useDomainStore>;
function init() {
	graphStore = useGraphStore();
	domainStore = useDomainStore();
}

export const useExpertKnowledgeStore = defineStore("expert-knowledge", () => {
	const nodePositions = ref<{ [fragmentId: string]: { [nodeId: string]: { x: number; y: number } } }>({});

	const openedFragmentId = ref<string | undefined>(undefined);
	const openedFragment = computed(() => {
		if (!graphStore) init();
		if (!openedFragmentId.value) return undefined;
		return graphStore.concept.fragment.byId(openedFragmentId.value);
	});

	function getNodePositions(fragmentId: string) {
		if (!fragmentId) return;
		if (!graphStore) init();
		graphStore.concept.functions.forEach((concept) => {
			if (!concept.context) concept.context = {};
			if (!concept.context["nta-pos"]) concept.context["nta-pos"] = {};
			if (!concept.context["nta-pos"][fragmentId]) concept.context["nta-pos"][fragmentId] = {};
			const pos = concept.context["nta-pos"][fragmentId];
			if (!nodePositions.value[fragmentId]) nodePositions.value[fragmentId] = {};
			nodePositions.value[fragmentId][concept.id] = {
				x: pos?.x || 0,
				y: pos?.y || 0,
			};
		});
		graphStore.concept.events.forEach((concept) => {
			if (!concept.context) concept.context = {};
			if (!concept.context["nta-pos"]) concept.context["nta-pos"] = {};
			if (!concept.context["nta-pos"][fragmentId]) concept.context["nta-pos"][fragmentId] = {};
			const pos = concept.context["nta-pos"][fragmentId];
			if (!nodePositions.value[fragmentId]) nodePositions.value[fragmentId] = {};
			nodePositions.value[fragmentId][concept.id] = {
				x: pos?.x || 0,
				y: pos?.y || 0,
			};
		});
	}

	watch(
		() => openedFragmentId.value,
		(newId, oldId) => {
			if (!domainStore || !graphStore) init();
			const domainId = router.currentRoute.value.params.domainId as string;
			if (oldId) {
				api().socket().domain(domainId).infmodel().view(oldId).off();
				api()
					.socket()
					.domain(domainId)
					.expknowledge()
					.fragment(openedFragmentId.value || "")
					.livePosition()
					.off();
			}
			if (newId) {
				api()
					.socket()
					.domain(domainId)
					.expknowledge()
					.fragment(openedFragmentId.value || "")
					.livePosition()
					.on((pos) => {
						nodePositions.value[newId] = pos;
					});
			}
		}
	);

	return {
		openedFragmentId,
		openedFragment,
		getNodePositions,
		nodePositions,
	};
});
